import { gql } from '@/utilities/gql';

export const NARRATIVE_CARD_ACTIONS_FRAGMENT = gql(`
  fragment NarrativeCardActionsFields on Narrative @_unmask {
    id
    isPrimary
    owner {
      publicId
    }
    companyId
    draftUpdate {
      id
    }
    latestPublishedUpdate {
      willLockAt
    }
    valuation {
      type
    }
  }
`);
